import { render, staticRenderFns } from "./alloy.vue?vue&type=template&id=9fcc71d8&"
import script from "./alloy.vue?vue&type=script&lang=js&"
export * from "./alloy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports